const MAX_SCORE = 5;

export default MAX_SCORE;
